import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from './cn.ts';

/** shadcn's badge as the kiosk's chip: a pill of short words on a soft ground. `soon` marks what is not built yet. */
export const badgeVariants = cva('inline-flex shrink-0 items-center gap-s1 rounded-chip text-caption whitespace-nowrap', {
  variants: {
    tone: {
      neutral: 'bg-sunk text-ink-2 h-s6 px-s3 font-semibold',
      brand: 'bg-brand-soft text-brand h-s6 px-s3 font-semibold',
      ok: 'bg-ok-soft text-ok h-s6 px-s3 font-semibold',
      warn: 'border border-warn-line bg-warn-soft text-warn-ink h-s6 px-s3 font-semibold',
      muted: 'bg-sunk text-muted h-s6 px-s3 font-semibold',
      soon: 'h-s5 bg-sunk px-s2 font-medium text-muted',
    },
  },
  defaultVariants: { tone: 'neutral' },
});

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>['tone']>;

export function UiBadge({ className, tone, ...props }: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span data-slot="badge" className={cn(badgeVariants({ tone }), className)} {...props} />;
}
